import React from 'react';
import { Bar } from 'react-chartjs-2';
const BrojPitanjaGrafikon = ({ brojPitanja }) => {
  // Podaci za grafikon
  const data = {
    labels: ['Broj pitanja'],
    datasets: [
      {
        label: 'Broj pitanja',
        data: [brojPitanja],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Opcije za grafikon
  const options = {
    scales: {
      y: {
        beginAtZero: true,
        max: Math.ceil(brojPitanja * 1.2), // Postavite maksimalnu vrijednost y-osovine
      },
    },
  };

  return (
    <div>
      <h2>Broj pitanja</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BrojPitanjaGrafikon;